import { render, staticRenderFns } from "./TheTab.vue?vue&type=template&id=528291e6&scoped=true&"
import script from "./TheTab.vue?vue&type=script&lang=js&"
export * from "./TheTab.vue?vue&type=script&lang=js&"
import style0 from "./TheTab.vue?vue&type=style&index=0&id=528291e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528291e6",
  null
  
)

export default component.exports